import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import * as XLSX from 'xlsx-js-style'; // Biblioteca para exportar a Excel

export default function DetalleInventario({ show, handleClose, inventario }) {
    const obtenerDetallesInventarioURL = "https://invio.datachile.site/Web/Inventarios/ObtenerDetalleInventario.php";
    const [detalles, setDetalles] = useState([]);

    useEffect(() => {
        if (inventario) {
            getDetallesInventario(inventario.idInventario);
        }
    }, [inventario]);

    const getDetallesInventario = async (idInventario) => {
        try {
            const response = await axios.post(obtenerDetallesInventarioURL, { idInventario });
            setDetalles(response.data);
        } catch (error) {
            console.error('Error al obtener detalles del inventario:', error);
        }
    };

    const handleExportExcel = () => {
        const workbook = XLSX.utils.book_new(); // Crear un nuevo libro de trabajo
        const worksheetData = []; // Datos para la hoja

        // Nombres de las columnas (sin la columna de imagen)
        const columnHeaders = ['Producto', 'Estado', 'Última Ubicación', 'Inventariado Por'];

        // Iterar sobre las ubicaciones y formatear los datos
        Object.entries(gruposPorUbicacion).forEach(([ubicacion, detalles]) => {
            // Agregar un encabezado para cada ubicación
            worksheetData.push([`Ubicación: ${ubicacion || 'Sin Ubicación'}`]); // Fila del título
            worksheetData.push(columnHeaders); // Agregar los nombres de las columnas
            detalles.forEach(detalle => {
                worksheetData.push([
                    detalle.producto,
                    detalle.estado,
                    detalle.ultima_ubicacion,
                    detalle.inventariado_por,
                ]);
            });
            worksheetData.push([]); // Fila vacía como separador
        });

        // Crear la hoja de cálculo
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Agregar bordes a las celdas
        const range = XLSX.utils.decode_range(worksheet['!ref']); // Rango de datos
        for (let row = range.s.r; row <= range.e.r; row++) {
            for (let col = range.s.c; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                const cell = worksheet[cellAddress];

                if (cell) {
                    // Agregar bordes a todas las celdas
                    cell.s = {
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                        },
                        alignment: { vertical: 'center', horizontal: 'center' },
                    };
                }
            }
        }

        // Combinar solo las celdas A y B del título de "Ubicación" para cada tabla
        const merges = [];
        let currentRow = 0;

        Object.entries(gruposPorUbicacion).forEach(([ubicacion, detalles]) => {
            const startRow = currentRow + 0; // La fila después del encabezado
            //  sCombinarolo las celdas A y B de la fila de título para "Ubicación"
            merges.push({ s: { r: startRow, c: 0 }, e: { r: startRow, c: 1 } });
            currentRow = startRow + 3 + detalles.length; // Avanzar al siguiente bloque de datos
        });

        worksheet['!merges'] = merges;

        // Ajustar automáticamente el tamaño de las columnas
        const colWidths = [];
        for (let col = range.s.c; col <= range.e.c; col++) {
            let maxLength = 0;
            for (let row = range.s.r; row <= range.e.r; row++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                const cell = worksheet[cellAddress];
                if (cell && cell.v) {
                    maxLength = Math.max(maxLength, String(cell.v).length);
                }
            }
            colWidths.push({ wch: maxLength + 2 }); // +2 para dejar un poco de espacio adicional
        }
        worksheet['!cols'] = colWidths;

        // Agregar la hoja al libro
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Detalles');

        // Generar y descargar el archivo Excel
        XLSX.writeFile(workbook, `Detalles_Inventario_${inventario.idInventario}.xlsx`);
    };

    const agruparPorUbicacion = () => {
        return detalles.reduce((grupos, detalle) => {
            const { ubicacion_actual } = detalle;
            if (!grupos[ubicacion_actual]) {
                grupos[ubicacion_actual] = [];
            }
            grupos[ubicacion_actual].push(detalle);
            return grupos;
        }, {});
    };

    const gruposPorUbicacion = agruparPorUbicacion();

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="modal-dialog-centered" style={{marginTop:"50px"}} >
            <Modal.Header closeButton>
                <Modal.Title>Detalles del Inventario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Button variant="success" onClick={handleExportExcel} className="mb-3">
                    Exportar a Excel
                </Button>
                {Object.keys(gruposPorUbicacion).length > 0 ? (
                    Object.keys(gruposPorUbicacion).map((ubicacion, idx) => (
                        <div key={idx} className="mb-4">
                            <h5 className="text-center">Ubicación Actual: {ubicacion}</h5>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Imagen</th>
                                        <th>Producto</th>
                                        <th>Estado</th>
                                        <th>Última Ubicación</th>
                                        <th>Inventariado por</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gruposPorUbicacion[ubicacion].map((detalle, index) => (
                                        <tr
                                            key={index}
                                            style={{
                                                backgroundColor: detalle.ultima_ubicacion === ubicacion ? '#d4edda' : '#ffeeba',
                                            }}
                                        >
                                            <td>
                                                <img
                                                    src={detalle.foto || 'https://demo.edgarleal.es/pda/SinImagen.png'}
                                                    alt={detalle.producto}
                                                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                />
                                            </td>
                                            <td>{detalle.producto}</td>
                                            <td>{detalle.estado}</td>
                                            <td>{detalle.ultima_ubicacion}</td>
                                            <td>{detalle.inventariado_por}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ))
                ) : (
                    <p className="text-center">No hay detalles disponibles</p>
                )}
            </Modal.Body>
        </Modal>
    );
}
